import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PaymentCallback = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => 
    localStorage.getItem('darkMode') === 'true'
  );
  const [status, setStatus] = useState('processing');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Dark mode check
    const darkMode = localStorage.getItem('darkMode') === 'true';
    setIsDarkMode(darkMode);
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }

    // Payment status check
    const params = new URLSearchParams(location.search);
    const paymentStatus = params.get('status');
    
    if (paymentStatus === 'success') {
      setTimeout(() => navigate('/payment/success'), 2000);
    } else if (paymentStatus === 'failed') {
      setTimeout(() => navigate('/payment/failed'), 2000);
    }
  }, [navigate, location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-[#0A0E23]">
      <div className="max-w-md w-full space-y-8 p-8 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            Ödeme İşleniyor
          </h2>
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">
            Lütfen bekleyin, ödemeniz işleniyor...
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCallback;